import type { Prediction } from '@h2h/shared';

export { pickOutcome, type PickOutcome } from '../../../lib/pickOutcome';

export function inlinePickLabel(prediction: Prediction, homeCode: string, awayCode: string): string {
  const winCode = prediction.outcome === 'HOME' ? homeCode : prediction.outcome === 'AWAY' ? awayCode : 'Draw';
  const boosts = prediction.legs?.length ?? 0;
  return boosts > 0 ? `${winCode} · +${boosts}` : winCode;
}
